import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/contexts/useAuth'

export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth()
  const location = useLocation()

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-background">
        <div className="flex flex-col items-center gap-3">
          <img
            src="/cellarwise_icon.png"
            alt=""
            className="h-12 w-12 animate-pulse rounded-lg"
          />
          <span className="font-heading text-sm text-muted-foreground">
            Loading...
          </span>
        </div>
      </div>
    )
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return <>{children}</>
}
